import { render } from "./CustomerDetails.vue?vue&type=template&id=40ac13e8&scoped=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"

import "./CustomerDetails.vue?vue&type=style&index=0&id=40ac13e8&lang=scss"
import "./CustomerDetails.vue?vue&type=style&index=1&id=40ac13e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ac13e8"]])

export default __exports__